import React from 'react'
import { Route, Redirect } from 'react-router-dom'
import { useSelector } from 'react-redux'

import { ROUTES } from 'utils/constants'

const OnlyLegalRoute = ({ component: Component, ...rest }) => {
	const user = useSelector(({ session }) => session)

	const isSolicitant = user.profile === 'solicitant'

	return (
		<Route
			{...rest}
			render={(props) =>
				isSolicitant ? (
					<Redirect to={ROUTES.demands} />
				) : (
					<Component {...props} />
				)
			}
		/>
	)
}

export default OnlyLegalRoute
